import {GetTireTransitApiResponse} from '@dms/api/core';

import {TireTransitFormType} from '../schemas/tireTransitFormSchema';

export const getDefaultValuesFromTireTransit = (
  data?: GetTireTransitApiResponse
): TireTransitFormType => ({
  homeBranchId: data?.homeBranchId ?? '',
  destinationBranch: data?.destinationBranch?.map((branch) => ({
    branchId: branch?.branchId ?? '',
    docSeriesId: branch?.docSeriesId ?? '',
    transitTimeDays: branch?.transitTimeDays ?? 0,
    isDefault: branch?.isDefault ?? false,
  })) ?? [
    {
      branchId: '',
      docSeriesId: '',
      transitTimeDays: 0,
      isDefault: false,
    },
  ],
});
